// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__YhR+4","games_section_title":"notification_games_section_title__y6PBL"};